const SERVER_URL =
  "https://lmp-registration-backend-nodejs-895924407291.asia-south1.run.app/admin/";
const LMP_URL =
  "https://lohana-mahaparishad-backend-nodejs-2mk6mheziq-de.a.run.app/user";
const IMAGE_URL = "https://storage.googleapis.com/kidsstreet-test/";
const SET_FORMAT = (amount) => {
  var formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });

  return formatter.format(amount);
};
module.exports = {
  SERVER_URL,
  LMP_URL,
  IMAGE_URL,
  SET_FORMAT,
};
